module.exports = __webpack_public_path__ + "static/img/magnifier.d73cfb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/magnifier.png
// module id = Y+KS
// module chunks = 1